export default "__VITE_ASSET__BXUxekE9__"